<template>
    <div :style="{ width: size + 'px', height: size + 'px', position: 'relative' }" class="chart-wrapper">
        <c-chart
            :data="{
                datasets: [
                    {
                        data: values,
                        backgroundColor: colors,
                        borderWidth: 0,
                        borderRadius: borderRadius,
                        spacing: spacing,
                    },
                ],
            }"
            :options="{
                animation: false,
                responsive: true,
                maintainAspectRatio: true,
                cutout: cutout,
                circumference: circumference,
                rotation: rotation,
                events: [],
                plugins: {
                    legend: false,
                },
            }"
            class="w-100"
            type="doughnut"
        />
        <div v-if="centerLabel" :style="centerLabelStyle" class="position-absolute translate-middle start-50 top-50">
            {{ centerLabel }}
        </div>
    </div>
</template>

<script setup>
import { CChart } from '@coreui/vue-chartjs';

const props = defineProps({
    values: {
        type: Array,
        required: true,
    },
    colors: {
        type: Array,
        default: () => ['#EBB6B7', '#6387fa'],
    },
    size: {
        type: Number,
        default: 60,
    },
    cutout: {
        type: String,
        default: '65%',
    },
    circumference: {
        type: Number,
        default: 360,
    },
    rotation: {
        type: Number,
        default: 0,
    },
    borderRadius: {
        type: Number,
        default: 2,
    },
    spacing: {
        type: Number,
        default: 2,
    },
    centerLabel: {
        type: [String, Number],
        default: null,
    },
    centerLabelStyle: {
        type: Object,
        default: () => ({
            color: '#EBB6B7',
            fontSize: '20px',
            fontWeight: '700',
            lineHeight: '12px',
        }),
    },
});
</script>

<style scoped>
.chart-wrapper {
    display: inline-block;
}
</style>
